export default function isDisabled(config) {
  return config === false || config === null;
}